import { Auth } from 'aws-amplify';
import { ClientMetadata } from 'amazon-cognito-identity-js';
import { CognitoUser } from '@aws-amplify/auth';

/**
 * Service for authentication operations via AWS Cognito.
 * Handles sign-in, sign-out, and challenge responses.
 */
class AuthServiceImpl {
  /**
   * Initiate sign-in for a user.
   * Returns a user object that can be used for challenge responses.
   * @param username - The username (email or phone number)
   */
  async signIn(username: string): Promise<CognitoUser> {
    return Auth.signIn(username);
  }

  /**
   * Sign out the current user.
   */
  async signOut(): Promise<void> {
    await Auth.signOut();
  }

  /**
   * Send a custom challenge answer (e.g., verification code).
   * @param user - The user object from signIn
   * @param answer - The challenge answer
   * @param options - Additional options for the challenge
   */
  async sendChallengeAnswer(
    user: CognitoUser,
    answer: string,
    options?: ClientMetadata,
  ): Promise<CognitoUser> {
    return Auth.sendCustomChallengeAnswer(user, answer, options);
  }
}

/**
 * Singleton instance for use across the application.
 */
export const AuthService = new AuthServiceImpl();

/**
 * Re-export AWS types so this serves as an anticorruption layer.
 */
export type { ClientMetadata, CognitoUser };
